// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"86398217","74":"7d33995c","311":"33196bb6","592":"a62538a1","766":"db932c42","818":"83f8c323"}[chunkId] + ".chunk.js";
};